import { injectIntl } from "react-intl";
import FilesUpload from "../Files/FilesUpload";
import { intlShape } from "../../shapes";
import {
  withBackend,
  backendShape,
  notifierShape,
  withNotifier,
} from "../../context";

type Props = {
  ticketId?: string;
  intl?: intlShape;
  backend?: backendShape;
  notifier?: notifierShape;
  returnResponse?: $TSFixMeFunction;
};

export function TicketAttachmentsForm({
  ticketId,
  backend,
  notifier,
  intl,
  returnResponse,
}: Props) {
  async function uploadFiles(files: $TSFixMe, index = 0) {
    try {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const response = await backend.upload(
        `/support/tickets/${ticketId}/attachments`,
        { name: files[index].name, file: files[index] },
      );
      if (returnResponse) {
        returnResponse(response);
      }
      if (files.length > index + 1) {
        await uploadFiles(files, index + 1);
      }
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showSuccess(
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        intl.formatMessage({
          id: "support.ticket.attachments.uploaded_notification",
        }),
      );
    } catch {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showError(
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        intl.formatMessage({
          id: "support.ticket.attachments.error_notification",
        }),
      );
    }
  }

  const onDrop = (acceptedFiles: $TSFixMe) => {
    acceptedFiles.forEach((file: $TSFixMe) => {
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
    });
    uploadFiles(acceptedFiles);
  };

  return (
    <FilesUpload
      onDrop={onDrop}
      // @ts-expect-error TS(2322) FIXME: Type '{ onDrop: (acceptedFiles: any) => void; auto... Remove this comment to see the full error message
      autofocus
      id="attachment-upload"
      name="filesUpload"
      multiple
      buildInWhiteList="image/*, video/*, .pdf, .zip"
      fileSizeLimit={1024 * 1024 * 10}
      dropzoneInfoPrefix="add_attachment"
    />
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type 'FC<WithIntlProps<WrappedComponen... Remove this comment to see the full error message
export default withBackend(withNotifier(injectIntl(TicketAttachmentsForm)));
